import * as React from "react"
import Button from "./button"

export default function StoryCardList(stories) {
  return (
    <>
      {stories.stories !== null &&
        stories.stories.map(story => {
          const {
            node: { uid, data },
          } = story

          return (
            <section
              key={uid}
              className={`flex flex-col md:flex-row max-w-6xl mx-auto mb-[20px] `}
            >
              <div className="flex flex-1 items-center justify-center bg-gray-100 my-6 md:mr-6 md:max-w-sm">
                <img
                  alt={
                    data.header_image.alt ||
                    `Image for the story ${data.title.text}`
                  }
                  src={data.header_image.url}
                />
              </div>
              <div className="flex-1 my-6">
                {uid && (
                  <a
                    href={`https://www.peopleforbikes.org/news/${uid}`}
                    className="no-underline font-bold leading-3"
                    target="_blank"
                  >
                    <h4 className="text-black font-sans text-2xl leading-9 m-0">
                      {data.title?.text}
                    </h4>
                  </a>
                )}
                {data.deck ? (
                  <p className="text-lg leading-7 mb-2">{data.deck}</p>
                ) : (
                  <div className="h-5"></div>
                )}
                {data.byline && (
                  <p className="text-gray-600 text-sm mb-4">By {data.byline}</p>
                )}
                {uid && (
                  <Button
                    link={`https://www.peopleforbikes.org/news/${uid}`}
                    text="Read More"
                    color="gray"
                    hover="gray"
                    type="small"
                  >
                    Read More
                  </Button>
                )}
              </div>
            </section>
          )
        })}
    </>
  )
}
